"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _require = require('es6-promisify'),
    promisify = _require.promisify;

var _require2 = require('browser-or-node'),
    isNode = _require2.isNode; // don't load fs native module if running in the browser


var fsOpen;
var fsRead;
var fsFStat;
var fsReadFile;

if (isNode) {
  // eslint-disable-next-line global-require
  var fs = require('fs');

  fsOpen = fs && promisify(fs.open);
  fsRead = fs && promisify(fs.read);
  fsFStat = fs && promisify(fs.fstat);
  fsReadFile = fs && promisify(fs.readFile);
}

var LocalFile = /*#__PURE__*/function () {
  function LocalFile(source) {
    (0, _classCallCheck2.default)(this, LocalFile);
    this.position = 0;
    this.filename = source;
    this.fd = fsOpen(this.filename, 'r');
  }

  (0, _createClass2.default)(LocalFile, [{
    key: "read",
    value: function () {
      var _read = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(buffer) {
        var offset,
            length,
            position,
            readPosition,
            ret,
            _args = arguments;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                offset = _args.length > 1 && _args[1] !== undefined ? _args[1] : 0;
                length = _args.length > 2 ? _args[2] : undefined;
                position = _args.length > 3 ? _args[3] : undefined;
                readPosition = position;

                if (readPosition === null) {
                  readPosition = this.position;
                  this.position += length;
                }

                _context.t0 = fsRead;
                _context.next = 8;
                return this.fd;

              case 8:
                _context.t1 = _context.sent;
                _context.t2 = buffer;
                _context.t3 = offset;
                _context.t4 = length;
                _context.t5 = position;
                _context.next = 15;
                return (0, _context.t0)(_context.t1, _context.t2, _context.t3, _context.t4, _context.t5);

              case 15:
                ret = _context.sent;

                if (!((0, _typeof2.default)(ret) === 'object')) {
                  _context.next = 18;
                  break;
                }

                return _context.abrupt("return", ret.bytesRead);

              case 18:
                return _context.abrupt("return", ret);

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function read(_x) {
        return _read.apply(this, arguments);
      }

      return read;
    }()
  }, {
    key: "readFile",
    value: function () {
      var _readFile = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", fsReadFile(this.filename));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function readFile() {
        return _readFile.apply(this, arguments);
      }

      return readFile;
    }()
  }, {
    key: "stat",
    value: function () {
      var _stat = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (this._stat) {
                  _context3.next = 8;
                  break;
                }

                _context3.t0 = fsFStat;
                _context3.next = 4;
                return this.fd;

              case 4:
                _context3.t1 = _context3.sent;
                _context3.next = 7;
                return (0, _context3.t0)(_context3.t1);

              case 7:
                this._stat = _context3.sent;

              case 8:
                return _context3.abrupt("return", this._stat);

              case 9:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function stat() {
        return _stat.apply(this, arguments);
      }

      return stat;
    }()
  }]);
  return LocalFile;
}();

exports.default = LocalFile;